<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" :close-on-click-modal="false" width="900px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="100px">
      <el-form-item label="客户信息：" prop="customerId" class="width100" v-if="popType != 2">
        <el-select v-model="form.customerId" :placeholder="`请输入关键词搜索`" filterable remote  :remote-method="searchUsers" :loading="loading">
          <el-option :label="`${item.name} (${item.pho})(${item.levelName})${item.cityCompanyName || ''}`" :value="item.id" v-for="item in clientOption" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="带教老师：" prop="techInfoIdForBig" class="width100">
        <el-select v-model="form.techInfoIdForBig" :placeholder="`请选择`" clearable filterable >
          <el-option :label="`${item.realName} (${item.mobile})(${item.levelName})`" :value="item.id" v-for="item in techOption" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修改原因：" prop="changeTechReasonForBig" class="width100" v-if="popType === 2">
        <el-input v-model="form.changeTechReasonForBig" :placeholder="`请输入修改原因`" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import clientListApi from '@/api/client/clientList'
import customerSubApi from '@/api/client/customerSub'
import technicalManageApi from '@/api/technical/technicianInfo'
import { debounce } from 'lodash';
function initFormBean() {
  const formBean = {
    customerId: null,
    techInfoIdForBig: null,
    changeTechReasonForBig: '',
  }
  return formBean
}

export default {
  //popType 0:新增 1:编辑 2:修改服务老师
  props: {
    popType: Number
  },
  data() {
    return {
      titleList: ['添加大客户', '编辑大客户', '修改带教老师'],
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      formRules: {
        customerId: [{ required: true, message: '请选择客户', trigger: 'change' }],
        techInfoIdForBig: [{ required: true, message: '请选择带教老师', trigger: 'change' }]
      },
      clientOption: [],
      techOption: []
    }
  },
  created() {
    this.getTechOption()
  },
  methods: {
    customerFilter(e) {
      this.debouncedGetOption(e)
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getOption(query)
        }, 500);
      } else {
        this.clientOption = [];
      }
    },
    resetForm() {
      this.form = initFormBean()
    },
    async getOption(e) {
      this.form.customerId = null
      let obj = { pageNo: 1, pageSize: 100, keywords: e, isDeparted: 0,customerTypes:3 }
      const { data } = await clientListApi.listForMini(obj)
      this.clientOption = data
    },
    async getTechOption(e) {
      this.form.techInfoIdForBig = null
      let obj = { pageNo: 1, pageSize: 1000, realName: e, levelIsBigCustomer: true,status: 10 }
      const { data } = await technicalManageApi.listPageForMini(obj)
      this.techOption = data.list
    },

    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form.customerId = row.id;
      this.form.techInfoIdForBig = row.customerSub.techInfoIdForBig;
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let params = { ...this.form }
          customerSubApi.create(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isLoading = false
          });
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
